/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateEventIndexPathParams, CandidateEventIndexResponse } from '../types/CandidateEventIndex'

/**
 * GET /candidates/:candidate/events
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEventController.php CandidateEventController::index
 */
export async function candidateEventIndex(
	candidate: CandidateEventIndexPathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEventIndexResponse>> {
	return axiosInstance.get(`/candidates/${candidate}/events`, config)
}
